<div class="MainContainer">
    <div class="MainTitleBar">
        <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'CashCollections' | translate }}</p>
        <div class="SectionHalfTitle SectionHalfTitleRight">
            <button (click)="GetShippingCompanies();AdjustShippingTransferListBankAccount();" style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'ImportShippingCompanyTransferList' | translate}}</button>
            <button (click)="OpenBankExtrasImport();" style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'ImportBankExtras' | translate}}</button>
            <button (click)="InitializeNewCashCollectionCCPage();" style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">add</i> {{'CashCollection' | translate}}</button>
            <button (click)="ExportCashCollectionsValues();" style="padding-left: 10px;background:#32aa3a;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}}</button>
        </div>
    </div>

    <div class="animated fadeInDown CashCollectionContainer" style="top:15%!important;width: 30%;left: 40%;" *ngIf="ShowSuggestionCashCollectionsContainerStepTwo">
        <div class="PopUpCloseContainer" (click)="ShowSuggestionCashCollectionsContainerStepTwo = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'IMPORTCASHCOLLECTIONS' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">
            <div class="PopUpBodyInfoRow">
                {{'AssociatedCashCollections' | translate}}: <span style="color:#32aa3a;font-weight: bold;">{{this.AssociatedCashCollections.length}}</span>
            </div>
            <div class="PopUpBodyInfoRow">
                {{'UnAssociatedCashCollections' | translate}}: <span style="color: red;font-weight: bold;">{{this.UnAssociatedCashCollections.length}}</span>
            </div>
            <div class="PopUpBodyInfoRow">
                
                <label id="example-radio-group-label">{{'PickImportType' | translate}}</label>
                <mat-radio-group
                  aria-labelledby="example-radio-group-label"
                  class="example-radio-group"
                  [(ngModel)]="CCImportType">
                  <mat-radio-button class="example-radio-button" *ngFor="let type of this.CashCollectImportTypes" [value]="type">
                    {{type.Name}}
                  </mat-radio-button>
                </mat-radio-group>
                <div>{{'ChosenImportType' | translate}}: {{CCImportType.Name}}</div>
                
            </div>

            <div class="PopUpBodyInfoRow">
              <mat-slide-toggle [(ngModel)]="DoNotImportDupplicateValues"></mat-slide-toggle>
              <p class="SliderText">
                <span *ngIf="DoNotImportDupplicateValues">{{'DoNotImportDupplicateValues' | translate}}</span>
                <span style="color: #fd4f57;font-weight: 400;" *ngIf="!DoNotImportDupplicateValues">{{'DupplicateValuesWillBeImported' | translate}}</span>
              </p>
            
            </div>
         </div>

         <div class="PopUpCommands">
          <button (click)="ImportCashCollections();" [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton">
              <span>{{'AcceptAndSave' | translate}}</span>
        </button>
        </div>
      </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestionCashCollectionsContainer" style="left: 16%;width: 83%;">
        <div class="PopUpCloseContainer" (click)="ShowSuggestionCashCollectionsContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer" style="height: auto;padding: 0;">
          <p>{{ 'DetectedCashCollections' | translate }}</p>

          <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;width: 95%;margin-left: 2.5%;margin-top: 15px;">
            <div class="ReceptionProductsCol" style="width: 5%;">
              {{ 'Invoice' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              {{ 'Client' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'CashColletcionDate' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'Value' | translate }} 
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'CashCollectionType' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;">
                {{ 'Currency' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;">
                {{ 'Receptions.ExchangeRate' | translate }}
              </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'Receptions.DecimalPercision' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;">
                {{ 'CollectionExternalID' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                {{ 'Actions' | translate }}
            </div>
          </div>
         </div>

         <div class="PopUpBody" style="margin-top: 5px;">

        <div class="ReceptionProductsContainer  top-box">

            <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>

            <div *ngIf="!loading">
                <div class="ReceptionProductsRow" *ngFor="let c of this.SuggestedCashCollections; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1, 'DupplicateCC': c.IsDuplicate == true, 'BigSpace': this.SuggestedCashCollections[i]?.CollectionExternalID != this.SuggestedCashCollections[i + 1]?.CollectionExternalID }">
                    <div class="ReceptionProductsCol" style="width: 5%;">
                     <span *ngIf="c.Status.ID == 1;">
                      {{c.DisplayValue}}
                    </span>
                     <span *ngIf="c.Status.ID == -1;">---</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                        <i matTooltip="{{ 'CCIsCompletingForInvoice' | translate }}" matTooltipClass='neutral-tool-tip' class="material-icons IsCompletingForInvoice" *ngIf="c.IsCompletingForInvoice == true;">check</i>
                        <span *ngIf="c.Status.ID == 1;">{{c.Client.Name}}</span>
                        <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
                        <span *ngIf="c.Status.ID == -1 && c.Client?.ID != null;">{{c.Client.Name}}</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.CollectionDateUI}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Value}} 
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Type.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        {{c.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                        <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                      </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        {{c.Currency.DecimalPrecision.ID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                        {{c.CollectionExternalID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        <i class="material-icons ReceptionProductEdit" (click)="OpenSuggestedCashCollectionModifier(c); ShowSuggestedCashCollectionModifier = true;">edit</i>
                        <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteSuggestedCashCollection(c);">close</i>
                    </div>
                </div>
            </div>
        </div>
        
         </div>

         <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
            <div *ngIf="this.SuggestedCashCollections != null && this.SuggestedCashCollections.length > 0 && !loading;">
                <div class="ReceptionProductsRow" *ngFor="let Total of this.Totals; let i=index;">
                    <div class="ReceptionProductsCol" style="width: 5%;">
                         
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                        {{this.SuggestedCashCollections.length}} {{'CashCollections' | translate}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        Total:
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        {{Total.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                      
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        
                    </div>
                </div>
            </div>
          <button (click)="AcceptBankExtrasStepOne();" [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton RightCommandButton" style="width: auto;">
              <span>{{'AcceptStep' | translate}}</span>
              <i class="material-icons">chevron_right</i>
        </button>
        </div>
      </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowBankExtrasImportContainer">
        <div class="PopUpCloseContainer" (click)="ShowBankExtrasImportContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'ImportBankExtras' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">

          <!-- <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{'ChoosePartner' | translate}}*</mat-label>
            <input class="BrandSelect"
                   type="text"
                   placeholder="{{'ChoosePartner' | translate}}"
                   matInput
                   [matAutocomplete]="auto1"
                   [(ngModel)]="this.Filter.SearchTerm"
                   (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                   (click)="InitializePartners();">
            <i class="material-icons BrandSelectCloseIcon" *ngIf="this.SelectedPartner?.Name?.length > 0;" (click)="ClearPartnerSearch();">close</i>
            <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.SelectedPartner?.Name?.length > 0) != true;">search</i>
            <mat-autocomplete #auto1="matAutocomplete">
              <mat-option *ngFor="let p of SearchedPartners" [value]="p" (click)="this.SelectedPartner = p; this.Filter.SearchTerm = p.Name;">
                {{p.Name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <div class="ReceptionProductsColDropDown" *ngIf="this.SelectedPartner?.ID?.length > 0;">
            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'FixedValue' | translate }}</mat-label>
                <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.ImportedFixedValue">
                <mat-icon matSuffix>calculate</mat-icon>
              </mat-form-field>
          </div>

          <div class="ReceptionProductsColDropDown" *ngIf="this.SelectedPartner?.ID?.length > 0;">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{'Currency' | translate}}</mat-label>
              <mat-select name="Currency" [(ngModel)]="this.ImportedCurrency">
                <mat-option *ngFor="let c of this.Currencies;" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->

          <!-- <mat-slide-toggle class="ProofInvoiceSUMSToggle" [(ngModel)]="this.ProofInvoiceSUMS" matTooltip="{{ 'ProofInvoiceSUMSDescription' | translate }}" matTooltipClass='neutral-tool-tip'>{{'ProofInvoiceSUMS' | translate}}</mat-slide-toggle> -->

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="ImportExtrasBankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="ReceptionProductsColDropDown">
                <div style="margin-bottom: 15px;">
                    <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                </div>
              </div>

              <div class="ReceptionProductsColDropDown">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'Delimiter' | translate }}</mat-label>
                    <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.ImportExtrasDelimiter">
                    <mat-icon matSuffix>calculate</mat-icon>
                  </mat-form-field>
              </div>
         
         </div>

         <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="GetBankExtrasCashCollections();">
              <span>{{'ImportDocument' | translate}}</span>
          </button>
        </div>
      </div>

      <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowImportShippingCompanyTransferListContainer">
        <div class="PopUpCloseContainer" (click)="ShowImportShippingCompanyTransferListContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'ImportShippingCompanyTransferList' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'ShippingCompanies' | translate }}</mat-label>
                <mat-select name="ShippingCompanies" [(ngModel)]="ShippingCompany" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.ShippingCompanies;" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select name="Currency" [(ngModel)]="ShippingTransferListCurrency" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="AdjustShippingTransferListBankAccount();">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="ShippingTransferListBankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.ShippingTransferListBankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="ReceptionProductsColDropDown">
                <div style="margin-bottom: 15px;">
                    <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                </div>
              </div>
         </div>

         <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="GetShippingCompanyTransferListCashCollections();">
              <span>{{'ImportDocument' | translate}}</span>
        </button>
        </div>
      </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowCashCollectionContainer" style="height: 70%;">
        <div class="PopUpCloseContainer" (click)="ShowCashCollectionContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p *ngIf="this.currentCashCollettion.ID > 0;">{{ 'UpdateCashCollection' | translate }}</p>
          <p *ngIf="!this.currentCashCollettion.ID > 0;">{{ 'NewCashCollection' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">

            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'AssociatedInvoice' | translate }}*</mat-label>
                <input *ngIf="!this.currentCashCollettion.InvoiceID?.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue" (click)="SearchInvoices(this.currentCashCollettion.DisplayValue);" (keyup)="SearchInvoices(this.currentCashCollettion.DisplayValue);">
                <input disabled="disabled" *ngIf="this.currentCashCollettion?.InvoiceID?.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue">
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentCashCollettion.InvoiceID?.length > 0;" (click)="this.currentCashCollettion.InvoiceID = '';this.currentCashCollettion.DisplayValue = '';this.currentCashCollettion.InvoiceDetailsID = null;">close</mat-icon>
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentCashCollettion.InvoiceID?.length > 0 && Invoices != null;" (click)="this.currentCashCollettion.DisplayValue = ''; Invoices = null">close</mat-icon>
            </mat-form-field>

            <div class="InvoiceSearchContainer" *ngIf="Invoices != null;">
                <div class="InvoiceSearchResult" *ngFor="let i of this.Invoices; let j=index;" (click)="SelectInvoiceForCashCollectionSearch(i);">
                   <div class="InvoiceSearchResultCol">
                    {{i.AccountingNumber.DisplayValue}}
                   </div>
                   <div class="InvoiceSearchResultCol" style="width: 40%;">
                    {{i.Client.Name}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{i.EventRegisterUIDate}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{i.Total.TotalQtyPriceVAT}} {{i.Currency.Name}}
                   </div>
                </div>
            </div>

            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
              <mat-label>{{ 'AssociatedPartner' | translate }}*</mat-label>
              <input *ngIf="!this.currentCashCollettion.Client?.ID?.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.currentCashCollettion.Client = Partners[0];resultsLength = 0;this.searchTerm = Partners[0].Name;">
              <input *ngIf="this.currentCashCollettion?.Client?.ID?.length > 0;" disabled="disabled" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Client.Name">
              <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentCashCollettion.Client?.ID?.length > 0;" (click)="this.currentCashCollettion.Client = null;">close</mat-icon>
              <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentCashCollettion.Client?.ID?.length > 0 && Partners != null;" (click)="this.currentCashCollettion.Client = null; Partners = null">close</mat-icon>
            </mat-form-field>

            <div class="InvoiceSearchContainer" *ngIf="Partners != null;">
              <div class="InvoiceSearchResult" *ngFor="let p of this.Partners; let j=index;" (click)="this.searchTerm = ''; this.currentCashCollettion.Client = p; Partners = null;">
                 <div class="InvoiceSearchResultCol">
                  {{p.Name}}
                 </div>
                 <div class="InvoiceSearchResultCol" style="width: 40%;">
                  
                 </div>
                 <div class="InvoiceSearchResultCol">
                  
                 </div>
                 <div class="InvoiceSearchResultCol">
                  
                 </div>
              </div>
            </div>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'CashCollectionType' | translate }}</mat-label>
                <mat-select name="CashCollectionType" [(ngModel)]="currentCashCollettion.Type" [compareWith]="compareFn">
                  <mat-option *ngFor="let type of this.CashCollectTypes;" [value]="type">
                    {{type.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select name="Currency" [(ngModel)]="currentCashCollettion.Currency" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="currentCashCollettion.BankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentCashCollettion.Currency.ExchangeRate > 0;">
                <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Currency.ExchangeRate">
                <mat-icon matSuffix>calculate</mat-icon>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="DecimalPercision" [(ngModel)]="currentCashCollettion.Currency.DecimalPrecision" [compareWith]="compareFn">
                  <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                    {{d.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

          <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
            <mat-label>{{ 'CollectionDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentCashCollettion.CollectionDate">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionValue' | translate }}* [{{this.currentCashCollettion.Currency.Name}}]</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Value" (change)="VerifyPriceModel(this.currentCashCollettion.Value);">
            <mat-icon matSuffix>monetization_on</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionExternalID' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.CollectionExternalID">
            <mat-icon matSuffix>qr_code_2</mat-icon>
          </mat-form-field>
         </div>

         <div class="PopUpCommands" style="height: 120px;">
          <button *ngIf="this.currentCashCollettion.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="UpdateCashCollection(this.currentCashCollettion);ShowCashCollectionContainer = false;">
              <span>{{'UpdateCashCollection' | translate}}</span>
          </button>
          <button *ngIf="!this.currentCashCollettion.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddCashCollection();ShowCashCollectionContainer = false;">
            <span>{{'Collect' | translate}}</span>
          </button>
          <button style="margin-top: 25px;" *ngIf="!this.currentCashCollettion.ID > 0;" [disabled]="parent.loading" mat-raised-button color="accent" matTooltip="{{ 'ProofInvoiceSUMSDescription' | translate }}" matTooltipClass='neutral-tool-tip' class="PopGeneralCommandButton" (click)="AllocateCashCollection();ShowCashCollectionContainer = false;">
            <span>{{'AllocateCashCollection' | translate}}</span>
          </button>
        </div>
      </div>

      <div class="animated fadeInDown CashCollectionContainer" style="top:15%!important;" *ngIf="ShowSuggestedCashCollectionModifier">
        <div class="PopUpCloseContainer" (click)="ShowSuggestedCashCollectionModifier = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p *ngIf="this.currentCashCollettion.ID > 0;">{{ 'UpdateCashCollection' | translate }}</p>
          <p *ngIf="!this.currentCashCollettion.ID > 0;">{{ 'NewCashCollection' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">

            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'AssociatedInvoice' | translate }}*</mat-label>
                <input *ngIf="!this.currentCashCollettion.InvoiceID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue" (click)="SearchInvoices(this.currentCashCollettion.DisplayValue);" (keyup)="SearchInvoices(this.currentCashCollettion.DisplayValue);">
                <input disabled="disabled" *ngIf="this.currentCashCollettion.InvoiceID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue">
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentCashCollettion.InvoiceID.length > 0;" (click)="this.currentCashCollettion.InvoiceID = '';this.currentCashCollettion.DisplayValue = '';DeallocateInvoiceFromCC();">close</mat-icon>
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentCashCollettion.InvoiceID.length > 0 && Invoices != null;" (click)="this.currentCashCollettion.DisplayValue = ''; Invoices = null; DeallocateInvoiceFromCC();">close</mat-icon>
            </mat-form-field>

            <div class="InvoiceSearchContainer" *ngIf="Invoices != null;">
                <div class="InvoiceSearchResult" *ngFor="let i of this.Invoices; let j=index;" (click)="SelectInvoiceForCashCollectionSearch(i);">
                   <div class="InvoiceSearchResultCol">
                    {{i.AccountingNumber.DisplayValue}}
                   </div>
                   <div class="InvoiceSearchResultCol" style="width: 40%;">
                    {{i.Client.Name}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{i.EventRegisterUIDate}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{i.Total.TotalQtyPriceVAT}} {{i.Currency.Name}}
                   </div>
                </div>
           </div>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'CashCollectionType' | translate }}</mat-label>
                <mat-select name="CashCollectionType" [(ngModel)]="currentCashCollettion.Type" [compareWith]="compareFn">
                  <mat-option *ngFor="let type of this.CashCollectTypes;" [value]="type">
                    {{type.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select name="Currency" [(ngModel)]="currentCashCollettion.Currency" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="currentCashCollettion.BankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentCashCollettion.Currency.ExchangeRate > 0;">
                <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Currency.ExchangeRate">
                <mat-icon matSuffix>calculate</mat-icon>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="DecimalPercision" [(ngModel)]="currentCashCollettion.Currency.DecimalPrecision" [compareWith]="compareFn">
                  <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                    {{d.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

          <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
            <mat-label>{{ 'CollectionDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentCashCollettion.CollectionDate">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionValue' | translate }}* [{{this.currentCashCollettion.Currency.Name}}]</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Value" (change)="VerifyPriceModel(this.currentCashCollettion.Value);">
            <mat-icon matSuffix>monetization_on</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionExternalID' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.CollectionExternalID">
            <mat-icon matSuffix>qr_code_2</mat-icon>
          </mat-form-field>
         </div>

         <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="ShowSuggestedCashCollectionModifier = false;">
              <span>{{'UpdateCashCollection' | translate}}</span>
        </button>
        </div>
      </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentCashCollettion = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false;DeleteCashCollection(currentCashCollettion.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="overlay" *ngIf="ShowImportShippingCompanyTransferListContainer || ShowSuggestionCashCollectionsContainerStepTwo || ShowSuggestionCashCollectionsContainer || ShowBankExtrasImportContainer || showEditSpendingPopUp || ShowDeleteSpendingQuestion || ShowCashCollectionContainer;" (click)="showEditSpendingPopUp = false; ShowDeleteSpendingQuestion = false;"></div>

    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetUpcomingPayments();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetUpcomingPayments();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
      </div>

      <div class="MainTitleBar" style="overflow: unset;">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>Filter</span>
        </div>
    
        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>
    
        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
                <div class="PopUpBodyRow">
                  <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                        <mat-label>{{ 'SearchClient' | translate }}*</mat-label>
                        <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)">
                        <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                        <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                      </mat-form-field>
    
                      <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                        <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm=p.Name;this.Filter.Partner = p;AddActiveFilter(p.Name, 'Partner');">
                            <p class="SearchResultTitle">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT.length;">{{p.VAT}}</span></p>
                        </div>
                      </div>
                </div>
                <div class="PopUpBodyOneThirddContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{'Currency' | translate}}</mat-label>
                    <mat-select name="Currency" [(ngModel)]="Filter.Currency">
                      <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Currency');">
                        {{c.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                </div>
                <div class="PopUpBodyRow">
                  <div class="PopUpBodyTwoThirdsContainer">

                  </div>
                  <div class="PopUpBodyTwoThirdsContainer">
                    
                  </div>
                  <div class="PopUpBodyTwoThirdsContainer">
                    
                  </div>
              </div>
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetUpcomingPayments();">{{ 'FilterInvoices' | translate }}</button>
            </div>
        </div>

          <div class="TotalDocCountContainer" *ngFor="let t of this.PaidTotals; let i=index;">
            <span style="float: right; text-transform: uppercase;">{{'Payment' | translate}}: {{t?.TotalQtyPriceVAT}} {{t?.Currency?.Name}}</span>
            <div class="PageSizeContainer">
            </div>
          </div>
    </div>

    <div class="MainBody"> 

        <div class="ReceptionProductsContainer">
          
            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
                <div class="ReceptionProductsCol" style="width: 2.5%;">
                  <mat-checkbox class="tableColCheckBox" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
                </div>
                <div class="ReceptionProductsCol" style="width: 2.5%;">
                  {{ 'NrCrt' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;text-align: left;">
                  {{ 'Reception' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;text-align: left;">
                  {{ 'DocumentNumber' | translate }}
              </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: left;">
                  {{ 'Client' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{ 'DueDate' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%; text-align: right; padding-right: 10px; font-weight: bold; color: #fd4f57;">
                  {{ 'PaymentValue' | translate }} 
                </div>
                <div class="ReceptionProductsCol" style="width: 1%; text-align: right; padding-right: 10px; font-weight: bold; color: #fd4f57;">
                  
                </div>
                <div class="ReceptionProductsCol" style="width: 9%; text-align: left; padding-right: 10px; font-weight: bold; color: #fd4f57;">
                  {{ 'TotalValue' | translate }} 
                </div>
                <div class="ReceptionProductsCol" style="width: 5%; text-align: left; font-weight: bold; color: #f60;">
                    {{ 'Currency' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    {{ 'Receptions.ExchangeRate' | translate }}
                  </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{ 'Receptions.DecimalPercision' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Actions' | translate }}
                </div>
            </div>

            <div class="ReceptionProductsRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>

            <div *ngIf="!loading">
                <div class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let c of this.Payments; let i=index;">
                    <div class="ReceptionProductsCol" style="width: 2.5%;">
                      <mat-checkbox class="tableColCheckBox" [(ngModel)]="c.IsSelected" (change)="CheckIfAnyChecked();"></mat-checkbox>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 2.5%;">
                      <span>{{i + 1}}</span>
                     </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;">
                     <span>{{c.Category?.Name}}</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;">
                           {{c.DisplayValue}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;text-align: left;">
                        <span>{{c.Supplier?.Name}}</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.PaymentDateUI}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%; text-align: right; padding-right: 10px; font-weight: bold; color: #fd4f57;">
                      <input type="text" class="PaymentTextBox" [(ngModel)]="c.Value" (change)="UpdateTotals(c.Currency); UpdatePaymentTotals(c.Currency);">
                    </div>
                    <div class="ReceptionProductsCol" style="width: 1%; text-align: right; padding-right: 10px; font-weight: bold; color: #fd4f57;">
                        /
                   </div>
                    <div class="ReceptionProductsCol" style="width: 9%; text-align: left; padding-right: 10px; font-weight: bold; color: #fd4f57;">
                       {{c.OriginalValue}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%; text-align: left; font-weight: bold; color: #f60;">
                        {{c.Currency?.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency?.ExchangeRate}}</span>
                      </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        {{c.Currency?.DecimalPrecision.ID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        <i (click)="GeneratePaymentDocumentEmail(this.Payments, c);" class="material-icons ReceptionProductEdit" matTooltip="{{ 'NotifyUpcomingInvoicesPaymentRequest' | translate }}" matTooltipClass='neutral-tool-tip'>outgoing_mail</i>
                    </div>
                </div>
            </div>

            <div *ngIf="this.Payments != null && this.Payments.length > 0 && !loading;">
                <div class="ReceptionProductsRow" *ngFor="let Total of this.Totals; let i=index;">
                    <div class="ReceptionProductsCol" style="width: 5%;">
        
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 25%;">
                        
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      Total:
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%; text-align: right; padding-right: 25px; font-weight: bold; color: #fd4f57;">
                      <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%; text-align: left; font-weight: bold; color: #f60;">
                      {{Total.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                      
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>